import * as React from 'react';
import { NoLogo } from './NoLogo';
import * as styles from './Logo.css';

interface ILogoProps {
  url?: string | null;
  alt?: string;
}

export function Logo({ url, alt = '' }: ILogoProps) {
  if (!url) {
    return <NoLogo />;
  }

  return (
    <div className={styles['container']}>
      <img src={url} alt={alt} className={styles['logo_img']} />
    </div>
  );
}
